// extracted by mini-css-extract-plugin
export var dataCell = "_mt-2";
export var dataRow = "_mt-0";
export var headerRow = "_mt-1";